/* eslint-disable unicorn/filename-case */
import { isNullOrWhiteSpace } from "./String";

export function isIdInParents(element: EventTarget | (EventTarget & HTMLElement), id: string): boolean {
  const el = element as HTMLElement;
  if (el == null) {
    return false;
  }

  if (isNullOrWhiteSpace(id)) {
    return false;
  }

  if (el.id === id) {
    return true;
  }

  if (el.parentElement != null) {
    return isIdInParents(el.parentElement, id);
  }

  return false;
}
